import { render } from "./menu.vue?vue&type=template&id=121e1e08&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=121e1e08&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/fresh/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121e1e08"]])

export default __exports__